export var Role;

(function (Role) {
  Role["Director"] = "director";
  Role["Writer"] = "writer";
  Role["Producer"] = "producer";
})(Role || (Role = {}));